export default class GetObservacionesIntervencionActiva {
  #repository

  constructor(repository) {
    this.#repository = repository
  }

  async execute(type) {
    return await this.#repository.getByTipoModulo(type)
  }
}
